import type { RootState } from "types";

export const getFilteredTopicsIds = (state: RootState) => state.domains.filteredTopics.ids;

export const getFilteredTopicsAreFetching = (state: RootState) => state.domains.filteredTopics.isFetching;

export const getFilteredTopicsIsPossibleNextPage = (state: RootState) =>
  state.domains.filteredTopics.hasPossibleNextPage;
